const IncomingCallTypeEnum = Object.freeze({
  Customer: 'Customer',
  Agent: 'Agent',
});

export default IncomingCallTypeEnum;
